// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tblMain[data-v-3d4ec4dc]{\r\n  /*width: 1000px;*/\n}\n.btn[data-v-3d4ec4dc]{\r\n  color: white !important;\r\n  margin: 5px;\r\n  width: 40px;\n}\r\n", ""]);
// Exports
module.exports = exports;
